import { useContext, useState } from 'react';
// import useFetch from 'renderer/hooks/useFetch';
import { AppContext, AppContextProvider } from './AppContext';
import jwt from '../jwtservice/jwtService';
import { useNavigate } from 'react-router-dom';

const AppContextContainer = ({ children }) => {
  const [activeTab, setActiveTab] = useState("RequestRefund");
  const [settings, setSettings] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState([]);

  const navigate = useNavigate();

  const handleActiveTab = (value) => {
    setActiveTab(value);
  };

  const routeDashboard = async (id) => {
    try {
      await jwt.getRfidCardCredit(id);
      navigate('/transaction', { state: { id } })
    } catch (e) {
      console.log("Error here")
      console.log(e)
      const { statusCode } = e.response?.data
      navigate('/error-page', { state: { statusCode } })
    }
  }

  const contextValue = {
    activeTab,
    settings,
    paymentMethod,
    setActiveTab,
    handleActiveTab,
    routeDashboard,
    setSettings,
    setPaymentMethod
  };

  return (
    <AppContextProvider value={contextValue}>{children}</AppContextProvider>
  );
};

export default AppContextContainer;

export const useAppContext = () => useContext(AppContext);
